import React, { createContext, useState, useContext } from "react";
import { getTimesheetApprovalsByApprover } from "../api/timesheetApi";

const PendingTimesheetsContext = createContext();

export function PendingTimesheetsProvider({ children }) {
  const [pendingTimesheetsCount, setPendingTimesheetsCount] = useState(0);

  const updatePendingCount = async (userId) => {
    if (!userId) {
      setPendingTimesheetsCount(0);
      return;
    }

    try {
      const timesheetApprovals = await getTimesheetApprovalsByApprover(userId);

      // Фильтруем только те табели, которые ожидают согласования текущего пользователя
      const pendingTimesheets =
        timesheetApprovals?.filter((approval) => {
          // Проверяем, есть ли шаг согласования для текущего пользователя со статусом "На рассмотрении"
          const userStep = approval.steps?.find(
            (step) => step.approver.id === userId
          );
          return userStep && userStep.status === "На рассмотрении";
        }) || [];

      setPendingTimesheetsCount(pendingTimesheets.length);
    } catch (error) {
      console.debug("Нет табелей на согласование");
      setPendingTimesheetsCount(0);
    }
  };

  return (
    <PendingTimesheetsContext.Provider
      value={{
        pendingTimesheetsCount,
        updatePendingCount,
      }}
    >
      {children}
    </PendingTimesheetsContext.Provider>
  );
}

export const usePendingTimesheets = () => useContext(PendingTimesheetsContext);
